import { Sidebar, SidebarType } from '../sidebar';

import React from 'react';
import styles from './StepperComposer.module.scss';
import useWindowSize from 'hooks/useWindowSize';

export type StepperComposerProps = {
  sidebarData: SidebarType;
  children: React.ReactNode;
};
export const StepperComposer = ({ sidebarData, children }: StepperComposerProps) => {
  const { isMobile } = useWindowSize();

  return (
    <div className={styles.signUpPage}>
      <Sidebar
        stepsData={sidebarData.stepsData}
        welcomeLabel={sidebarData.welcomeLabel}
        className={sidebarData.className}
        chatTriggerLabel={isMobile ? undefined : sidebarData.chatTriggerLabel}
      />
      {children}
    </div>
  );
};
